import { EventHandler } from "../../util/event/EventHandler";
import { ResizeEvent } from "../renderer/Renderer";
import { AbstractControl } from "./AbstractControl";
import { ButtonGroup } from "./ButtonGroup";
import { TitanButton } from "./TitanButton";
import { TitanPanel } from "./TitanPanel";
/**
 * Paging.ts
 */
export class Paging extends AbstractControl {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        super.create();
        this.panel = TitanPanel.createPanel(this, "pagingPanel", this.uiProperties.panelProperties);
        this.createButtons();
    }
    createPageButton() {
        let button = new TitanButton(this.uiProperties.buttonProperties);
        button.onClick(this.handleButtonSelected, this);
        button.setGroup(this.group);
        button.setData(this.buttons.length);
        return button;
    }
    createButtons() {
        this.buttons = [];
        this.group = new ButtonGroup();
    }
    handleButtonSelected(button) {
        let previousIndex = this.data.getPageIndex();
        let index = button.getData();
        let difference = index - previousIndex;
        if (difference != 0) {
            this.data.setPageIndex(index);
            this.callHandler(this.changeHandler);
            this.dispatchCore(ResizeEvent.TRACK_TARGETS);
        }
    }
    next() {
        if (this.data.isActive()) {
            this.data.next();
            this.updateSelected();
            this.callHandler(this.changeHandler);
            this.dispatchCore(ResizeEvent.TRACK_TARGETS);
        }
    }
    previous() {
        if (this.data.isActive()) {
            this.data.previous();
            this.updateSelected();
            this.callHandler(this.changeHandler);
            this.dispatchCore(ResizeEvent.TRACK_TARGETS);
        }
    }
    setIndex(index) {
        let currentIndex = this.data.getPageIndex();
        if (currentIndex != index) {
            this.data.setPageIndex(index);
            this.updateSelected();
        }
    }
    updateSelected() {
        let button = this.buttons[this.data.getPageIndex()];
        this.group.setSelected(button, true);
    }
    update(data) {
        this.data = data;
        this.updateButtons();
    }
    updateButtons() {
        this.panel.removeAll();
        let pageIndex = this.data.getPageIndex();
        let totalPages = this.data.getTotalPages();
        let buttonsToCreate = totalPages - this.buttons.length;
        if (buttonsToCreate > 0) {
            for (let i = 0; i < buttonsToCreate; i++) {
                this.buttons.push(this.createPageButton());
            }
        }
        this.buttons[pageIndex].setSelected(true);
        for (let i = 0; i < totalPages; i++) {
            this.panel.addToPanel(this.buttons[i], false);
        }
        this.panel.arrange();
    }
    getIndex() {
        return this.data.getPageIndex();
    }
    isActive() {
        return this.data.isActive();
    }
    getData() {
        return this.data;
    }
    onChange(handler, scope) {
        this.changeHandler = new EventHandler(handler, scope);
    }
}
//# sourceMappingURL=Paging.js.map